import { produce } from 'immer';

import { sortDynamicFieldsSchema } from 'utils/forms';

import { SET_MASTER_DATA } from 'store/auth/actions';

import { FORM_ACTION_TYPE, FORM_PDF_ACTION_TYPE, FORMS_ACTION_TYPE } from '../actions';

const initialState = {
  normalizedItems: {},
  formsInfo: null,
  formsInfoVersion: 0,
  expandedTreeItems: [],
  dynamicFieldsSchema: [],
  templateVariablesSchema: [],
  loanSpecificForms: [],
};

const formsReducer = (state = initialState, { type, payload }) =>
  produce(state, draft => {
    switch (type) {
      case FORMS_ACTION_TYPE.GET_FORMS:
        draft.normalizedItems = payload;
        break;

      case FORMS_ACTION_TYPE.GET_FORMS_INFO:
        draft.formsInfo = payload;
        break;

      case FORMS_ACTION_TYPE.GET_DYNAMIC_FIELDS_SCHEMAS:
        draft.dynamicFieldsSchema = sortDynamicFieldsSchema(payload);
        break;

      case FORMS_ACTION_TYPE.ADD_TEMPLATE_VARIABLES_TO_DYNAMIC_FIELDS_SCHEMAS:
        draft.templateVariablesSchema = payload;
        break;

      case FORM_ACTION_TYPE.UPDATE_FORM_TEMPLATE:
      case FORMS_ACTION_TYPE.CREATE_FORM:
      case FORM_PDF_ACTION_TYPE.UPDATE_FORM_TEMPLATE:

      case FORMS_ACTION_TYPE.UPDATE_FORM: {
        draft.normalizedItems[payload.formId] = payload;
        draft.formsInfo = null;
        draft.formsInfoVersion += 1;
        break;
      }

      case FORMS_ACTION_TYPE.TOGGLE_TREE_ITEM: {
        if (Array.isArray(payload)) {
          draft.expandedTreeItems = payload;
          break;
        }

        const { expandedTreeItems } = draft;
        const isItemAlreadyExpanded = expandedTreeItems.includes(payload);

        draft.expandedTreeItems = isItemAlreadyExpanded
          ? expandedTreeItems.filter(item => item !== payload)
          : [...expandedTreeItems, payload];

        break;
      }

      case FORMS_ACTION_TYPE.GET_LOAN_SPECIFIC_FORMS: {
        draft.loanSpecificForms = payload;
        break;
      }

      case FORMS_ACTION_TYPE.DELETE_FORM:
        delete draft.normalizedItems[payload.formId];
        draft.formsInfo = null;
        draft.formsInfoVersion += 1;
        break;

      // Identity swap (login, impersonation soft reLogin) must not serve the previous company's forms.
      case SET_MASTER_DATA:
        draft.formsInfo = null;
        draft.formsInfoVersion += 1;
        break;

      default:
        return state;
    }
  });

export default formsReducer;
